module.exports = __webpack_public_path__ + "img/more.dbe28b55.png";